import { ErrorBoundary } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { FlatList, StyleSheet, View } from 'react-native';

import { DividendHistoryEntityNormalized } from '../../../store/dividendHistory/types';
import { DividendHistoryItem } from '../DividendHistoryItem';
import { DividendHistoryItemEmpty } from '../DividendHistoryItemEmpty';
import { DividendHistoryItemLoading } from '../DividendHistoryItemLoading';

export namespace DividendHistoryListTypes {
  export type Props = {
    isLoading: boolean;
    handleRefresh: VoidFunction;
    data: DividendHistoryEntityNormalized[];
    isMobile?: boolean;
    error?: Error;
  };
}

const styles = StyleSheet.create({
  container: {
    marginLeft: -Utils.Token.ToInt(Spacing, 'inset.xs'),
    marginRight: -Utils.Token.ToInt(Spacing, 'inset.xs'),
    flex: 1,
  },
  containerDesktop: {
    paddingBottom: Utils.Token.ToInt(Spacing, 'inset.xs'),
  },
  containerMobile: {},
  separator: {
    height: Utils.Token.ToInt(Spacing, 'inset.xs'),
  },
});

const Separator = () => <View style={styles.separator} />;

export const DividendHistoryList: React.FC<DividendHistoryListTypes.Props> = ({
  isLoading,
  handleRefresh,
  data,
  isMobile,
  error,
}) => {
  if (error) {
    return <ErrorBoundary onRefresh={handleRefresh} />;
  }

  return (
    <FlatList
      data={data}
      style={[styles.container, isMobile ? styles.containerMobile : styles.containerDesktop]}
      onEndReachedThreshold={0.4}
      ItemSeparatorComponent={Separator}
      showsVerticalScrollIndicator={false}
      renderItem={({ item }) => <DividendHistoryItem item={item} />}
      ListEmptyComponent={
        isLoading ? (
          <>
            <DividendHistoryItemLoading />
            <Separator />
            <DividendHistoryItemLoading />
            <Separator />
            <DividendHistoryItemLoading />
          </>
        ) : (
          <DividendHistoryItemEmpty />
        )
      }
      ListFooterComponent={isLoading && data.length ? <DividendHistoryItemLoading /> : null}
    />
  );
};
